import React from 'react';
import { UnitTimersStore } from './unit-timers-store';
import { UnitTimersStoreContext } from './unit-timers-store-context';

export function useUnitTimersStore(): UnitTimersStore {
    const value = React.useContext(UnitTimersStoreContext);
    if (!value) {
        throw new Error('Unexpectedly did not find UnitTimersStore on context.');
    }
    return value;
}
